import { apiService } from '@/services/APIService';

export default {
  linkAccount() {
    return apiService.post('/telegram/assign-code');
  },
  unlinkAccount(payload) {
    return apiService.post('/user/forget-telegram', payload);
  },
  /**
   * payload: { phone_number: string }; // номер телефона без +
   */
  sendAuthCode(payload) {
    return apiService.post('/public/telegram/auth', payload);
  },
};
